import * as React from 'react';
import { IContextMenu } from './interfaces';
import { Menu, MenuList } from '@mui/material';

export const ContextMenu: React.FC<IContextMenu> = ({
  children,
  onClose,
  open,
  anchorEl,
}): JSX.Element => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        list: {
          dense: true,
          sx: { py: 0.25 }, // verklein verticale padding
        },
      }}
    >
      {children}
    </Menu>
  );
};
